module.exports = __webpack_public_path__ + "static/media/web.3052a6c0.jpg";